import Subheader from '../components/Subheader.jsx';

import Button from 'react-bootstrap/Button';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Form from 'react-bootstrap/Form';

import Input from '@mui/material/Input';
// import TextareaAutosize from '@mui/base/TextareaAutosize';

import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import '../styles.css';

function ContactUsPage() {
	const form = useRef();

	const sendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				'service_2dyww6w',
				'template_7nd0dyr',
				form.current,
				'NYyBpZpn8UTTcaP_H'
			)
			.then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);

		alert('Your message has been sent');
	};

	return (
		<div className="contactusPage">
			<Subheader text="Contact Us" />
			<form
				className="contactusPage_Form"
				ref={form}
				onSubmit={sendEmail}
			>
				<Input
					className="contactusPage_input"
					placeholder="Name"
					type="text"
					name="from_name"
					id="input"
				/>
				<Input
					className="contactusPage_input"
					placeholder="Email"
					type="email"
					name="user_email"
					id="input"
				/>
				<textarea
					className="contactusPage_input contactusPage_messageinput"
					cols="50"
					rows="5"
					placeholder="Message"
					name="message"
					id="input"
				/>
				{/* <Input
					multiline
					placeholder="Message"
					name="message"
				/> */}
				<Button
					className="homepage-section2_buttonlink"
					as="input"
					type="submit"
					value="Submit"
					outlined
				></Button>
			</form>

			{/* <div className="contactuspageInstagramSection">
				<h3 className="contactusPageEmailSection_heading">
					Connect With Us On Instagram!
				</h3>

				<a
					href="https://www.instagram.com/aplgin/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<Button className="homepage-section2_buttonlink">
						Go to Instagram Page
					</Button>
				</a>
			</div> */}

			{/* <div className="contactusPageEmailSection">
				<h3 className="contactusPageEmailSection_heading">
					Email
				</h3>
				<a
					target="_blank"
					rel="noreferrer"
					href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=aplwinclub@apl.edu.in"
					className="contactusPage_link"
				>
					aplwinclub@apl.edu.in
				</a>

				<br />

				<a
					target="_blank"
					rel="noreferrer"
					href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=vedanthramji@apl.edu.in"
					className="contactusPage_link"
				>
					vedanthramji@apl.edu.in (developer)
				</a>
			</div>

			 */}
		</div>
	);
}

export default ContactUsPage;
